module.exports = __webpack_public_path__ + "static/media/id.132f96df.png";